import React, { useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import Socket from "socket";
import _ from "lodash";
import ball from "assets/images/tw/crystal-ball.png";
import sad from "assets/images/tw/sad.png";
import happy from "assets/images/tw/happy.png";
import {
  divVariants,
  fadeVariants,
  fade_bounce_delay_variants
} from "shared/components/animations";

const TWResult = ({
  isActivePlayer,
  correctGuess,
  roomId,
  screens,
  buzzer_sound,
  default_audio_effect
}) => {
  const button_text = _.get(screens, "result.button_text", "NEXT PLAYER");
  const delay_time = _.get(screens, "result.delay_time", 10);
  const [counter, setCounter] = useState(delay_time);

  useEffect(() => {
    let timer;
    timer =
      isActivePlayer &&
      counter > 0 &&
      setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && onUpdateStatus("update");
    return () => clearInterval(timer);
  }, [counter, isActivePlayer]);

  const buttonPressAction = () => {
    const data = {
      action: "update-status",
      roomId
    };
    Socket.sendMessage(data);
  };

  const onUpdateStatus = useCallback(
    _.debounce((type) => buttonPressAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );

  useEffect(() => {
    if (isActivePlayer && !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, isActivePlayer, default_audio_effect]);

  return (
    <section className="tw-result-wrapper">
      <motion.section
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="tw-result"
      >
        <motion.div
          variants={fade_bounce_delay_variants}
          className="status-box"
        >
          <h2 className="status">{correctGuess ? "great job!" : "SORRY..."}</h2>
        </motion.div>
        <motion.div variants={fadeVariants} className="ball-wrapper">
          <img src={ball} className="img-fluid ball-img" alt="" />
          <motion.div variants={fade_bounce_delay_variants}>
            {correctGuess ? (
              <div className="happy-emoji">
                <img src={happy} className="img-fluid" alt="" />
              </div>
            ) : (
              <div className="sad-emoji">
                <img src={sad} className="img-fluid" alt="" />
              </div>
            )}
          </motion.div>
        </motion.div>
        {isActivePlayer && (
          <motion.div
            variants={fade_bounce_delay_variants}
            className="tw-btn-wrapper"
            onClick={onUpdateStatus}
          >
            <div className="tw-btn">
              {button_text} ({counter})
            </div>
          </motion.div>
        )}
      </motion.section>
    </section>
  );
};

export default TWResult;
